import React from 'react'

import { useResizeSidebar } from './useResizeSidebar'
import PageList from '../../../components/PageList'

import {
  PageListWrapper,
  Sidebar,
  SidebarWidthGuide,
} from './PageCanvasSidebar.styles'

interface PageCanvasSidebarProps {
  resizeable?: boolean
}

// This is just the presentational component. Here we will render the items
// within the Sidebar and add the resize functinality. This will make our
// unit tests super easy to write
export const PageSidebar: React.FC<PageCanvasSidebarProps> = props => {
  const { children, resizeable = true } = props
  const {
    sidebarWidth,
    setTrackMouse,
    minWidth,
    maxWidth,
    restoreInitialWidth,
    restoreInitialSidebarWidth,
  } = useResizeSidebar()

  return (
    <Sidebar
      style={{ minWidth, maxWidth, width: sidebarWidth }}
      aria-label="Canvas pages list"
      restoreInitialWidth={restoreInitialWidth}
    >
      {children}
      {resizeable && (
        <SidebarWidthGuide
          aria-label="Sidebar resize handler"
          onMouseDown={() => {
            setTrackMouse(true)
          }}
          onDoubleClick={restoreInitialSidebarWidth}
        />
      )}
    </Sidebar>
  )
}

const PageCanvasSidebar = () => (
  <PageSidebar>
    <PageListWrapper>
      <PageList />
    </PageListWrapper>
  </PageSidebar>
)

export default React.memo(PageCanvasSidebar)
